import React, {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom"
//@ts-ignore
import _, {over} from "lodash";
import {getUrl} from "src/service/files.service";
import NoFile from "src/assets/png/NoFile.png";
import {FileContext} from "../../File.context";
import {supportViewer} from "../../properies.file";
import styles from "./MediasContainer.module.scss";
import {useTranslation} from "react-i18next";
import {BgImgWithLazy} from "src/components/shared/BgImgWithLazy/BgImgWithLazy";
import {Modal} from "antd";
import ReactPlayer from "react-player";
import Lightbox from "react-image-lightbox";
import check_mark from "src/assets/png/check_mark.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlay} from "@fortawesome/free-solid-svg-icons";

const defaultLitmitOfset = 30;

const UIMediaItem = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [loadMore, setLoadMore] = useState(false);

  const [offsetFile, setOffsetFile]: any = useState(0);
  const [offsetFolder, setOffsetFolde]: any = useState(0);
  const fileContext: any = useContext(FileContext);

  const [isOpenImg, setIsOpenImg] = useState(false);
  const [urlPreviewImg, setUrlPreviewImg] = useState("");

  const [isOpenVideo, setIsOpenVideo] = useState(false);
  const [urlPreviewVideo, setUrlPreviewVideo] = useState("");

  const [urlImage, setUrlImage]: any = useState("");
  const [isOver, setIsOver]: any = useState(false);
  let defaultBigSize = "40";
  let boxSizeWidth = "290px";
  let boxSizeHeight = "200px";

  const checkGetUrlFile = async () => {
    if (!props.file?.file_app_id) {
      setUrlImage(NoFile);
    } else {
      let url: any =
        window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER +
        "/downloadFile?fileId=" +
        props.file?.file_app_id +
        "&size=1024&onTrashReqIgnore=true";
      url = await getUrl(
        url,
        props.file?.file_app_id,
        1024,
        props.file?.file_type
      );
      setUrlImage(url);
    }
  };

  useEffect(() => {
    checkGetUrlFile();
  }, []);

  const clickPreviewImage = async () => {
    if (supportViewer.images.indexOf(props.file?.file_type) > -1) {
      let url: any =
        window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER +
        "/downloadFile?fileId=" +
        props.file?.file_app_id +
        "&size=1024&onTrashReqIgnore=true";
      url = await getUrl(
        url,
        props.file?.file_app_id,
        1024,
        props.file?.file_type
      );
      setUrlPreviewImg(url);
      setIsOpenImg(true);
    } else if (supportViewer.video.indexOf(props.file?.file_type) > -1) {
      let url =
        window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER +
        "/downloadFile?fileId=" +
        props.file?.file_app_id +
        "&onTrashReqIgnore=true";
      setUrlPreviewVideo(url);
      setIsOpenVideo(true);
    }
  };

  const handleClickVideoModal = (e: any) => {
    console.log(e);
  };

  const isSelected = () => {
    let filters = fileContext.filesSelected?.filter((item: any) => {
      return item.file_app_id === props.file.file_app_id;
    });
    if (filters.length === 0) return false;
    else return true;
  };

  const checkFile = () => {
    let files = fileContext.filesSelected;
    let filters = fileContext.filesSelected?.filter((item: any) => {
      return item.file_app_id === props.file.file_app_id;
    });
    if (filters.length === 0) {
      files.push(props.file);
    }
    fileContext.setFilesSelected(Object.assign([], files));
  };

  const unCheckFile = () => {
    let files = fileContext.filesSelected;
    let i = fileContext.filesSelected?.findIndex((item: any) => {
      return item.file_app_id === props.file.file_app_id;
    });
    if (i !== -1) {
      files.splice(i, 1);
    }
    fileContext.setFilesSelected(Object.assign([], files));
  };

  const mouseOver = () => {
    setIsOver(true);
  };

  const mouseLeave = () => {
    setIsOver(false);
  };

  return (
    <>
      {isSelected() && (
        <div className={styles.boxMediaItem}
          style={{ position: "relative" }}
        >
          <div
            className={
              isSelected() ? styles.box_symbol_selected : styles.box_symbol
            }
            onClick={unCheckFile}
          >
            <div
              style={{
                backgroundImage: `url(${check_mark})`,
              }}
              className={styles.collect_symbol}
            ></div>
          </div>
        </div>
      )}

      {!isSelected() && (isOver || fileContext.filesSelected?.length !== 0) && (
        <div className={styles.boxMediaItem}
          style={{ position: "relative" }}
        >
          <div
            className={styles.box_symbol}
            onClick={checkFile}
            onMouseEnter={mouseOver}
          >
            <div
              style={{
                backgroundImage: `url(${check_mark})`,
              }}
              className={styles.collect_symbol}
            ></div>
          </div>
        </div>
      )}
      <div
        className={styles.boxMediaItem}
        style={{ position: "relative" }}
        onClick={clickPreviewImage}
        onMouseEnter={mouseOver}
        onMouseOver={mouseOver}
        onMouseLeave={mouseLeave}
        onMouseOut={mouseLeave}
      >
        {supportViewer.video.indexOf(props.file?.file_type) > -1 && (
          <div className={styles.boxMediaItem}>
            <div className={styles.playVideoIcon} >
              <FontAwesomeIcon icon={faPlay} style={{ color: "white", cursor: "pointer" }} size={"4x"} />
            </div>
          </div>
        )}
        <BgImgWithLazy
          containerClassName="img"
          classPlaceholder={"img-gray"}
          src={urlImage}
          style={{
            filter: false ? "sepia(1)" : "unset",
            height: boxSizeHeight,
            // maxWidth: boxSizeWidth,
            borderRadius: "0px",
          }}
        />
      </div>
      {
        isOpenImg && (
          <Lightbox
            wrapperClassName={"lightboxOverride"}
            mainSrc={urlPreviewImg}
            onCloseRequest={() => setIsOpenImg(false)}
            reactModalStyle={{
              content: {
                zIndex: "9999",
              },
              overlay: {
                zIndex: "9999",
              },
            }}
          />
        )
      }
      {
        isOpenVideo && (
          <Modal
            centered
            className={styles.modalOveride}
            visible={true}
            footer={null}
            onCancel={() => setIsOpenVideo(false)}
          >
            <div
              style={{ width: "100%" }}
            // onClick={handleClickVideoModal}
            >
              <ReactPlayer
                // onReady={videAudioOnReady}
                controls={true}
                className={styles.reactPlayer}
                url={urlPreviewVideo}
              />
            </div>
          </Modal>
        )
      }
    </>
  );
};

export default UIMediaItem;
